import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6bmpg4myaw: FaireBrandEntity = {
  token: "b_6bmpg4myaw",
  type: "brand",
  name: "Ollie Blossom",
  avatarUrl:
    "https://cdn.faire.com/fastly/33ba539f0dec2845ccec7eee153b8374d019ec82337f287f08152c97544649de.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/d9581de8863f5175c80ee161f21e18a4536e0481f04c11b2b17ccd13d1578325.png",
  logoUrl:
    "https://cdn.faire.com/fastly/33ba539f0dec2845ccec7eee153b8374d019ec82337f287f08152c97544649de.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d9581de8863f5175c80ee161f21e18a4536e0481f04c11b2b17ccd13d1578325.png",
  location: "los angels, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a carbon neutral, eco-friendly company. All of our items are compostable. We are a women/mom-founded company; we have all women employees. \n\nWe started after years of the pandemic when we noticed people were not taking the time for their mental health. We wanted to create a moment for someone to take for self-care and to slow down. People need to know that their mental health DOES matter. \n\nWe hope you love what we have created and can tell the care we have taken into our offerings. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:21.693Z",
    importedBy: "entity-db-cli",
  },
};
